let Api = {
	"AUTH_LIST": "/system/w/user/viewMenu/list", //菜单列表
	"MENUSERVICE_LIST": "/system/w/user/menuService/list", //菜单列表
	"SYS_UPLOADIMG": "/system/w/uploadImg", //上传图片
	"SYS_UPLOADIMG_N": "/system/n/uploadImg", //上传图片无权限
	'UPLOADAUD': '/system/w/uploadAud', //上传视频
	'UPLOADFILE': '/system/w/uploadFile', //上传文件
	"MASTER_LOGIN": "/system/login?ltype=plat&utype=master", //主账户登录
	"SUB_LOGIN": "/system/login?ltype=plat&utype=sub", //子账户登录
	"W_PLATMEMB_FINDMEMBPAGELIST": "/system/w/platMemb/findMembPageList", //分页查询商家列表
	"W_PLATMEMB_PLATFINDMEMBINFO": "/system/w/platMemb/platFindMembInfo", //查询商家详细信息
	"W_PLATMEMB_UPDATEENABLESTATUS": "/system/w/platMemb/updateEnableStatus", //修改启用禁用状态
	"W_PLATMEMB_RESETPWD": "/system/w/platMemb/resetPwd", //重置密码
	"W_PLATMEMBAUTH_FINDPAGELIST": "/system/w/platMerchantAuth/findPageList", //分页查询商家认证列表信息
	"W_PLATMEMBAUTH_GETDETAIL": "/system/w/platMerchantAuth/getDetail", //分页查询商家认证列表信息
	"W_PLATMEMBAUTH_AUTHENTPDATAINFO": "/system/w/platMerchantAuth/authEntpDataInfo", //企业认证审核处理
	"W_PLATMEMB_FINDMEMBOPENSERVER": "/system/w/platMemb/findMembOpenServer", //查询用户已开通服务列表
	"W_PLATMEMB_MEMBOPENSERVERUPDATESTATUS": "/system/w/platMemb/membOpenServerUpdateStatus", //修改已开通服务状态
	"W_PLATMEMB_CONFIGDIFAMUPDATE": "/system/w/platMemb/configDifamUpdate", //修改数字基地配置信息
	"W_PLATMEMB_FINDMEMBVERIFIEDPAGELIST": "/system/w/platMemb/findMembVerifiedPageList", //分页查询服务列表
  
  
	"LOGIN": "/system/login?ltype=plat&utype=master",//登录
	"LOGOUT": "/system/w/logout",//登出
	"SYSTEM_W_MEMB_USER_UPDPWD": "/system/w/memb/user/updPwd", //修改登录密码
	"SYSTEM_W_MEMB_SENDFORREGTEL": "/system/w/memb/sendForRegTel", //手机号验证码发送
	"SYSTEM_W_MEMB_SAVEREGMOBILE": "/system/w/memb/saveRegMobile", //保存注册手机号
  "SYSTEM_W_CATEGORYMAGE_FINDCOMMMAGELIST": "/system/w/categoryMage/findCommMageList", //改版后的品类,品种选择,精准搜索到品种
	"SYSTEM_W_PLATINFOMAGE_FINDINFO": "/system/w/PlatInfoMage/findInfo", //获取平台信息
	"SYSTEM_W_PLATINFOMAGE_SAVEORUPDATE": "/system/w/PlatInfoMage/saveOrUpdate", //新增或修改
	"SYSTEM_W_CATEGORYMAGE_FINDCOMMMAGETREE": "/system/w/categoryMage/findCommMageTree", //查询基础品类树
	
	
	"SYSTEM_W_PLATMEMBAUTH_EXPORTMEMBAUTH": "/system/w/platMerchantAuth/exportMembAuth", //导出商家认证信息列表
	"W_PLATMEMB_EXPORTMEMB": "/system/w/platMemb/exportMemb", //分页查询商家列表导出
	"W_ENTPSERVICE_FINDPAGELIST": "/system/w/EntpService/findPageList", //分页查询服务列表
	"W_ENTPSERVICE_FINDLIST": "/system/w/EntpService/findList", //查询服务列表
	"W_ENTPSERVICE_FINDINFO": "/system/w/EntpService/findInfo", //查询服务详情
	"W_ENTPSERVICE_DEL": "/system/w/EntpService/del", //删除服务
	"W_ENTPSERVICE_SAVEORUPDATE": "/system/w/EntpService/saveOrUpdate", //新增服务
	"W_ENTPSERVICETYPE_FINDLIST": "/system/w/entpServiceType/findPageList", //查询服务类目列表分页
	"W_ENTPSERVICETYPE_FINDALL": "/system/w/entpServiceType/findList", //查询服务类目列表
	"W_ENTPSERVICETYPE_FINDINFO": "/system/w/entpServiceType/findInfo", //查询服务类目详情
	"W_ENTPSERVICETYPE_DEL": "/system/w/entpServiceType/del", //删除服务类目
	"W_ENTPSERVICETYPE_SAVEORUPDATE": "/system/w/entpServiceType/saveOrUpdate", //新增服务类目
	"W_ENTPSERVICE_ENTPMENULIST": "/system/w/EntpService/entpMenuList", //企业菜单列表
	"W_ENTPAUTH_UPDATEBANKACCOUNT": "/system/w/merchantAuth/updateBankAccount", //修改结算账户
	"SYSTEM_MEMB_CHECKMOBILEEXIST": "/system/memb/checkMobileExist", //验证手机号是否已经存在
	"SYSTEM_MOBILE_VALCODE_CREATE": "/system/mobile/valCode/create", //注册获取验证码
	'UPLOADFILE': '/system/w/uploadFile', //上传文件
	"SYSTEM_W_REALPERSONAUTH_FINDPAGELIST": "/system/w/realPersonAuth/findPageList", //平台查询实人认证申请列表
	"SYSTEM_W_REALPERSONAUTH_AUTHEXAM": "/system/w/realPersonAuth/authExam", //平台审核实人认证信息
	"SYSTEM_W_REALPERSONAUTH_FINDINFO": "/system/w/realPersonAuth/findInfo", //平台查询实人认证查询详细信息
	"SYSTEM_W_ENTPAUTH_FINDPAGELIST": "/system/w/entpAuth/findPageList", //平台查询企业认证申请列表
	"SYSTEM_W_ENTPAUTH_FINDINFO": "/system/w/entpAuth/findInfo", //平台查询企业认证详细信息
	"SYSTEM_W_ENTPAUTH_AUTHEXAM": "/system/w/entpAuth/authExam", //平台审核企业认证信息

	"HISTORY_SAVE": "/system/w/History/save", //浏览记录新增
	"HISTORY_FINDLIST": "/system/w/History/findList", //浏览记录列表


	"GET_MAP_N_FINDDEFAULT": "/difam/n/findDefault", //地图配置详情

	"SYSTEM_N_FINDALLPLATCONFIG": "/system/n/findAllPlatConfig", //
	"TENTCENTIM_USERSIGN": "/system/w/tencentIM/userSign", //获取用户加密串-即时通讯


	



  
  
  
  
  
  
  
}
module.exports = Api